import { render } from "./ResetPasswordModal.vue?vue&type=template&id=dc2fe99a"
import script from "./ResetPasswordModal.vue?vue&type=script&lang=js"
export * from "./ResetPasswordModal.vue?vue&type=script&lang=js"

import "./ResetPasswordModal.vue?vue&type=style&index=0&id=dc2fe99a&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__